var TEMPLATE_URL = require('./change.password.html');
angular.module('ikeweb.user').controller('ChangePasswordController', ['$scope', 'loginService',
    function($scope, loginService) {

        $scope.password = {};

        var loading = false;

        function isLoading() {
            return loading;
        }

        function done() {
            loading = false;
        }

        function updatePassword() {

            loading = true;
            loginService.changePassword($scope.password.current, $scope.password.new)
                .then(function() {
                    done();
                    $scope.$broadcast($scope.dismissEvent);
                }, done);
        }

        function reset() {
            $scope.password = {};
        }

        this.update = updatePassword;
        this.isLoading = isLoading;
        this.reset = reset;
    }
]);

angular.module('ikeweb.user').directive('changePassword', [

    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            link: function($scope, $element, attrs, ctrl) {
                $scope.$on($scope.displayEvent, ctrl.reset);
            },
            controller: 'ChangePasswordController',
            controllerAs: 'ctrl'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/password/change/change.password.directive.js
// module id = 471
// module chunks = 0